// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type { BaseResponseCcpassConfigFoundResponse, PutCcpassConfigsBody } from '../types';

/**
 * 查询配置
 *
 * @export
 * @tags ccpass-config-controller
 * @link [GET] /ccpassConfigs
 */
export function getCcpassConfigs(): Promise<BaseResponseCcpassConfigFoundResponse>;
export function getCcpassConfigs(
    options: ApiOptions<never, never>
): Promise<BaseResponseCcpassConfigFoundResponse>;
export function getCcpassConfigs(
    options?: ApiOptions<never, never>
): Promise<BaseResponseCcpassConfigFoundResponse> {
    return request<never, never, never>('/ccpassConfigs', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getCcpassConfigs',
    });
}

/**
 * 新增/修改配置
 *
 * @export
 * @tags ccpass-config-controller
 * @link [PUT] /ccpassConfigs
 */
export function putCcpassConfigs(
    data: PutCcpassConfigsBody
): Promise<BaseResponseCcpassConfigFoundResponse>;
export function putCcpassConfigs(
    data: PutCcpassConfigsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseCcpassConfigFoundResponse>;
export function putCcpassConfigs(
    data: PutCcpassConfigsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseCcpassConfigFoundResponse> {
    return request<PutCcpassConfigsBody, never, never>('/ccpassConfigs', {
        ...options,
        data,
        method: 'put',
        __$requestCalleeName: 'putCcpassConfigs',
    });
}

export const meta = [
    { tags: ['ccpass-config-controller'], path: '/ccpassConfigs', method: 'get' },
    { tags: ['ccpass-config-controller'], path: '/ccpassConfigs', method: 'put' },
];
